// File: src/pages/TermsPage.jsx
import React from 'react';
import { useNavigate , useSearchParams} from 'react-router-dom';

export default function TermsPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const role = searchParams.get('role'); // ✅ Lấy role từ URL

  const handleBack = () => {
    // ✅ Logic điều hướng thông minh
    if (role === 'business') navigate('/register-business');
    else if (role === 'candidate') navigate('/register-candidate');
    else navigate(-1); 
  };

  return (
    <div className="min-h-screen bg-gray-50 pt-28 pb-12 px-4 sm:px-6 lg:px-8 font-sans text-gray-800">
      <div className="max-w-4xl mx-auto bg-white shadow-xl rounded-2xl overflow-hidden">
        
        {/* --- HEADER --- */}
        <div className="bg-gradient-to-r from-blue-600 to-indigo-700 px-8 py-12 text-center text-white relative overflow-hidden">
            <div className="absolute top-0 left-0 w-full h-full opacity-10 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')]"></div>
            <div className="relative z-10">
                <div className="w-16 h-16 bg-white/20 rounded-2xl mx-auto flex items-center justify-center mb-4 backdrop-blur-sm">
                    <span className="material-symbols-outlined text-4xl text-white">gavel</span>
                </div>
                <h1 className="text-3xl md:text-4xl font-extrabold mb-2 tracking-tight">Điều khoản sử dụng dịch vụ</h1>
                <p className="text-blue-100 font-medium">SkillMatch - Nền tảng Tuyển dụng & Đánh giá năng lực</p>
                <p className="text-xs text-blue-200 mt-4 uppercase tracking-widest">Cập nhật lần cuối: 01/02/2026</p>
            </div>
        </div>

        {/* --- CONTENT BODY --- */}
        <div className="p-8 md:p-12 space-y-10">
            
            {/* Giới thiệu */}
            <div className="text-sm text-gray-600 leading-relaxed border-l-4 border-blue-500 pl-4 bg-blue-50 py-3 rounded-r-lg">
                Chào mừng bạn đến với <strong>SkillMatch</strong>. Khi bạn truy cập, đăng ký hoặc sử dụng dịch vụ của chúng tôi, bạn đồng ý tuân thủ các điều khoản dưới đây. Vui lòng đọc kỹ trước khi bắt đầu.
            </div>

            {/* Section 1 */}
            <section>
                <h2 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-3">
                    <span className="w-8 h-8 rounded-full bg-blue-100 text-blue-600 flex items-center justify-center font-bold text-sm">1</span>
                    Quy định chung về Tài khoản
                </h2>
                <ul className="list-disc pl-14 space-y-2 text-gray-600 text-sm leading-6">
                    <li><strong>Thông tin đăng ký:</strong> Bạn cam kết cung cấp thông tin chính xác, đầy đủ (Email, Họ tên, SĐT). Đối với Doanh nghiệp, Mã số thuế (MST) phải hợp lệ.</li>
                    <li><strong>Bảo mật:</strong> Bạn chịu trách nhiệm bảo mật mật khẩu và mã OTP. SkillMatch không chịu trách nhiệm cho các tổn thất do lộ thông tin đăng nhập từ phía người dùng.</li>
                    <li><strong>Định danh:</strong> Mỗi cá nhân/tổ chức chỉ được sử dụng một email để định danh. Chúng tôi có quyền khóa các tài khoản trùng lặp hoặc giả mạo.</li>
                </ul>
            </section>

            {/* Section 2 */}
            <section>
                <h2 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-3">
                    <span className="w-8 h-8 rounded-full bg-blue-100 text-blue-600 flex items-center justify-center font-bold text-sm">2</span>
                    Dịch vụ dành cho Ứng viên (Candidate)
                </h2>
                <div className="pl-11 space-y-4 text-gray-600 text-sm leading-6">
                    <p><strong>Hồ sơ năng lực:</strong> Bạn cam kết các thông tin trong CV, lịch sử làm việc và kỹ năng khai báo là trung thực.</p>
                    <div className="bg-orange-50 border border-orange-100 rounded-lg p-4">
                        <p className="font-bold text-orange-800 mb-2 flex items-center gap-2">
                            <span className="material-symbols-outlined text-base">warning</span>
                            Quy định thi tuyển & AI Monitor:
                        </p>
                        <ul className="list-disc pl-5 space-y-1 text-orange-700">
                            <li>Hệ thống sử dụng công nghệ giám sát (Webcam, Quay màn hình, Khóa trình duyệt) để đảm bảo tính công bằng.</li>
                            <li>Bằng việc tham gia bài kiểm tra, bạn <strong>đồng ý</strong> cho phép SkillMatch thu thập dữ liệu hình ảnh/video trong quá trình làm bài.</li>
                            <li>Nếu phát hiện gian lận (thi hộ, tài liệu trái phép, thoát trình duyệt), kết quả sẽ bị hủy và tài khoản có thể bị khóa vĩnh viễn.</li>
                        </ul>
                    </div>
                </div>
            </section>

            {/* Section 3 */}
            <section>
                <h2 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-3">
                    <span className="w-8 h-8 rounded-full bg-blue-100 text-blue-600 flex items-center justify-center font-bold text-sm">3</span>
                    Dịch vụ dành cho Doanh nghiệp (Business)
                </h2>
                <ul className="list-disc pl-14 space-y-2 text-gray-600 text-sm leading-6">
                    <li><strong>Đăng tin tuyển dụng:</strong> Nội dung tin đăng phải hợp pháp, không phân biệt đối xử, không chứa nội dung lừa đảo hoặc đa cấp.</li>
                    <li><strong>Tạo bài Test:</strong> Bạn chịu trách nhiệm về nội dung sở hữu trí tuệ của các câu hỏi tự tải lên.</li>
                    <li><strong>Gói dịch vụ:</strong> Các gói Pro/Premium sẽ kích hoạt ngay sau khi thanh toán. SkillMatch không hỗ trợ hoàn tiền trừ lỗi kỹ thuật từ hệ thống.</li>
                </ul>
            </section>

            {/* Section 4 */}
            <section>
                <h2 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-3">
                    <span className="w-8 h-8 rounded-full bg-blue-100 text-blue-600 flex items-center justify-center font-bold text-sm">4</span>
                    Xử lý vi phạm & Quyền Admin
                </h2>
                <p className="pl-11 text-gray-600 text-sm leading-6 mb-2">Admin có quyền <strong>khóa (block)</strong> hoặc <strong>xóa vĩnh viễn</strong> tài khoản không cần báo trước nếu phát hiện:</p>
                <ul className="list-disc pl-14 space-y-1 text-gray-600 text-sm leading-6">
                    <li>Spam tin tuyển dụng hoặc hồ sơ rác.</li>
                    <li>Có hành vi gian lận trong thi cử.</li>
                    <li>Sử dụng ngôn từ thiếu văn hóa, quấy rối người dùng khác.</li>
                </ul>
            </section>

            {/* Section 5 */}
            <section>
                <h2 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-3">
                    <span className="w-8 h-8 rounded-full bg-blue-100 text-blue-600 flex items-center justify-center font-bold text-sm">5</span>
                    Miễn trừ trách nhiệm
                </h2>
                <p className="pl-11 text-gray-600 text-sm leading-6">
                    SkillMatch là nền tảng kết nối và cung cấp công cụ đánh giá. Chúng tôi không cam kết 100% ứng viên sẽ tìm được việc hoặc doanh nghiệp sẽ tuyển được người. Chúng tôi luôn cố gắng duy trì hệ thống ổn định, nhưng không chịu trách nhiệm cho các gián đoạn bất khả kháng.
                </p>
            </section>

        </div>

        {/* --- FOOTER ACTIONS --- */}
        <div className="bg-gray-50 px-8 py-6 border-t border-gray-100 flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-xs text-gray-500 text-center md:text-left">
                Mọi thắc mắc vui lòng liên hệ: <a href="mailto:skillmatchvn@gmail.com" className="text-blue-600 hover:underline">skillmatchvn@gmail.com</a>
            </p>
            <div className="flex gap-3 w-full md:w-auto">
                <button 
                    onClick={handleBack}
                    className="flex-1 md:flex-none px-6 py-2.5 border border-gray-300 rounded-lg text-gray-700 font-semibold hover:bg-gray-100 transition-all text-sm"
                >
                    {/* Hiển thị text dynamic */}
                    Quay lại {role === 'business' ? 'Đăng ký Doanh nghiệp' : (role === 'candidate' ? 'Đăng ký Ứng viên' : '')}
                </button>
                <button 
                    onClick={() => navigate('/login')}
                    className="flex-1 md:flex-none px-6 py-2.5 bg-blue-600 rounded-lg text-white font-semibold hover:bg-blue-700 shadow-md hover:shadow-lg transition-all text-sm"
                >
                    Đăng nhập ngay
                </button>
            </div>
        </div>

      </div>
    </div>
  );
}